// extracted by mini-css-extract-plugin
export default {"notesContainer":"Notes_notesContainer__+HVY9","notes":"Notes_notes__a0Wi3","note":"Notes_note__MCsz6","userName":"Notes_userName__1s8u8"};